import { Link } from "wouter";

export function Footer() {
  return (
    <footer className="border-t border-border/40 bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-24">
          <div className="md:col-span-6 space-y-4">
            <h3 className="font-serif text-2xl font-semibold">
              Shateara Davis<span className="text-primary">.</span>
            </h3>
            <p className="text-muted-foreground max-w-xs text-balance leading-relaxed">
              A multidisciplinary professional working across data analysis, conversion-focused website design, and app development.
            </p>
          </div>
          
          <div className="md:col-span-3 space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground">Navigation</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <Link href="/" className="hover:text-primary transition-colors">About</Link>
              </li>
              <li>
                <Link href="/services" className="hover:text-primary transition-colors">Services</Link>
              </li>
              <li>
                <Link href="/blog" className="hover:text-primary transition-colors">Blog</Link>
              </li>
              <li>
                <Link href="/projects" className="hover:text-primary transition-colors">Projects</Link>
              </li>
              <li>
                <Link href="/contact" className="hover:text-primary transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3 space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground">Connect</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <a href="https://shatearadavis.medium.com/" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">Medium</a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/shateara-davis-90750a89/" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">LinkedIn</a>
              </li>
              <li>
                <a href="https://x.com/ShatearaD94502" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">X (Twitter)</a>
              </li>
              <li>
                <a href="https://www.kaggle.com/shatearad" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">Kaggle</a>
              </li>
              <li>
                <a href="https://www.youtube.com/@ShatearaDavis" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">YouTube</a>
              </li>
              <li>
                <a href="https://calendly.com/shateara-davis-proton" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">Book a Consultation</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-16 pt-8 border-t border-border/40 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Shateara Davis. All rights reserved.</p>
          <p>Thoughtfully designed and built.</p>
        </div>
      </div>
    </footer>
  );
}
